/* ---------------------------------------------------------------------------
   Sparkline — mini gráfico de línea con relleno degradado.
   Extraído del Dashboard para reutilizarse en KPIs y en el Design System.
--------------------------------------------------------------------------- */

interface SparklineProps {
  /** Path SVG en el viewBox 0 0 200 46 (sin cerrar el área). */
  d: string;
  /** Color del trazo y del degradado (hex). */
  color: string;
  className?: string;
}

export function Sparkline({ d, color, className }: SparklineProps) {
  const id = `sp-${color.replace("#", "")}`;
  return (
    <svg
      viewBox="0 0 200 46"
      preserveAspectRatio="none"
      className={className ?? "my-2 h-11 w-full"}
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={color} stopOpacity="0.35" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={`${d} L200,46 L0,46 Z`} fill={`url(#${id})`} />
      <path
        d={d}
        fill="none"
        stroke={color}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
